// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Button,
    Dialog,
    DialogHeader,
    DialogContent,
    DialogFooter,
    Heading,
    Text
} from '@locus-taxy/neo-ui';

import { navigationPromptFactory } from 'common/components/core/router';

const AlertDialog = ({
    cancelLabel,
    children,
    confirmLabel,
    isOpen,
    onCancel,
    onConfirm,
    title
}): React.Node => (
    <Dialog isOpen={isOpen} sticky onDismiss={onCancel} dismissOnEscape={false}>
        <DialogHeader>
            <Heading truncated>{title}</Heading>
        </DialogHeader>

        <DialogContent>
            <Text size="regular">{children}</Text>
        </DialogContent>

        <DialogFooter>
            <Button appearance="solid" palette="primary" onClick={onCancel}>
                {cancelLabel}
            </Button>
            <Button onClick={onConfirm}>{confirmLabel}</Button>
        </DialogFooter>
    </Dialog>
);

const NavigationPrompt = navigationPromptFactory({
    Prompt: AlertDialog
});

type Props = {
    when: boolean
};

const UnsavedChangesNavigationPrompt = ({ when }: Props): React.Node => {
    const { t } = useTranslation();

    return (
        <NavigationPrompt
            when={when}
            cancelLabel={t('translations:stay')}
            confirmLabel={t('translations:leave')}
            title={t('translations:leaveThisPage')}
        >
            {t('translations:unsavedChangesWillBeLost')}
        </NavigationPrompt>
    );
};

export default UnsavedChangesNavigationPrompt;
